<template>
  <div class="body-container">
    <div class="box-wrapper">
      <div class="learn-study-box text-center">
        <div class="pt-11 pb-11 pl-21 pr-21 border-bottom learn-study-header">
          <div class="row">
            <div class="col-md-1 col-1">
              <i class="fa fa-angle-left" style="color: #c4c4c4; font-size: 32px; cursor: pointer" @click="goBack()"></i>
            </div>
            <div
              class="col-md-10 col-10 text-center learn-study-title"
              v-translate:dynamic_string="{
                key: `${data.id}_sectionTitle`,
                val: lang,
                html: data.sectionTitle
              }"
            >
              {{ data.sectionTitle }}
            </div>
            <div class="col-md-1 col-1"></div>
          </div>
        </div>
        <div class="learn-content select-scroll">
          <p class="learn-content-text" v-quill-html:getParticipantStudyVideos.src="data.id"></p>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Bitrise, Widget } from "@/components/services/participant-service";
export default {
  name: "details",
  props: ["data"],
  data() {
    return {
      bitrise: new Bitrise(),
      widget: new Widget()
    };
  },
  computed: {
    ...mapGetters(["getParticipantStudyVideos"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  methods: {
    goBack() {
      this.$emit("back", true);
    }
  }
};
</script>
<style>
.learn-study-header {
  background-color: #fff;
}
.learn-study-title,
.learn-study-box .learn-study-title {
  color: #4a4a4a !important;
}
.learn-content-text img {
  max-width: 100% !important;
}
</style>
